module.exports = __webpack_public_path__ + "img/1604.c4c71322.png";